import PropTypes from 'prop-types'
import type { CustomRuleDataFragment } from 'apollo/graphql.types'

type CustomRuleCondition = {
  __typename?: string
  type: string
  operation: string
  categories: string[]
}

type CustomRuleResult = {
  __typename?: string
  type: string
  action: string
  sentiment?: string
  categories?: [string] | null
}

export type CustomRule = {
  id: string
  name: string
  description?: string
  conditions: CustomRuleCondition[]
  results: CustomRuleResult[]
  __typename?: string
}

export const normalizeCustomRule = (input: CustomRuleDataFragment) => ({
  id: input?.id || '',
  name: input?.name || '',
  description: input?.description || '',
  conditions:
    input?.conditions?.map(condition => ({
      type: condition?.type || '',
      operation: condition?.operation || '',
      sentiments: condition?.sentiments || [],
      authors: condition?.authors || [],
      feeds: condition?.feeds || [],
      sources: condition?.sources || [],
      categories: condition?.categories || [],
    })) || [],
  results:
    input?.results?.map(result => ({
      type: result?.type || '',
      action: result?.action || '',
      sentiment: result?.sentiment || '',
      categories: result?.categories || [],
    })) || [],
  extendTo: input?.extendTo
    ? {
        retweets: input.extendTo.retweets || null,
        commentsAndReplies: input.extendTo.commentsAndReplies || null,
      }
    : null,
})

export type NormalizedRule = ReturnType<typeof normalizeCustomRule>

// Shapes
const customRuleConditionShape = PropTypes.shape({
  type: PropTypes.string.isRequired,
  operation: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(PropTypes.string),
})

const customRuleResultShape = PropTypes.shape({
  type: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  sentiment: PropTypes.string,
})

export const customRuleShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  conditions: PropTypes.arrayOf(customRuleConditionShape).isRequired,
  results: PropTypes.arrayOf(customRuleResultShape).isRequired,
})
